import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import { useNavigate } from "react-router-dom";

function Welcome() {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/features#mrnudges");
    };

    return (
   <>
    <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>
            
            {/* Content */}
              <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-4-fullhd is-4-widescreen is-6-desktop is-8-tablet is-10-mobile">
                <h1 className='pt-4 px-0 pb-0 m-0'>
                    Welcome to the new Nudgemail
                </h1>
                <h2 className='pt-2 px-0 m-0 is-bold'>
                    Nudgemail gets a fresh look. The same reliable reminders now have attachments. 🎉
                </h2>
                <h3 className='pt-2 m-0 is-normal'>
                    Nudgemail has had a glow-up! We've updated our logo, colors, and tone, but don't worry—the email delivery you know and trust remains as great (and absurdly reliable) as ever. Your Nudges will still land exactly when you need them, keeping you on track without the bloat of traditional task managers.
                </h3>
                <h3 className='pt-5 m-0 is-normal'>
                    But that's not all! We're rolling out a brand-new feature—attachments for paid users. Now, you can Nudge yourself not just with reminders, but with important files, spreadsheets, or that meme you swear is work-related. If you're an existing customer, <a href="/upgrade" className='textLink'>upgrade to the paid plan</a> and unlock attachments—because some Nudges deserve a little extra! 📎
                </h3>

                <h3 className='pt-5 m-0 is-normal'>
                    Here's the fun part: we want to hear from you! Do you have a feature request? Curious about <a onClick={handleClick} className='textLink'>Mr. Nudges</a> and his questionable work ethic? <a href="/contact" className='textLink'>Let us know</a>—tell us what you love, what you miss, and what features you'd like to see next. 🚀
                </h3>
              </div>
            </div>
        </div>
          
          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
    </section>
   </>
  );
}

export default Welcome;
